const mapStyle: google.maps.MapTypeStyle[] = [
  {
    featureType: 'administrative',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#9EC4E7',
      },
    ],
  },
  {
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'administrative.country',
    elementType: 'labels.text',
    stylers: [
      {
        visibility: 'on',
      },
    ],
  },
  {
    featureType: 'administrative.country',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#4e4e4f',
      },
    ],
  },
  {
    featureType: 'administrative.country',
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#ffffff',
      },
    ],
  },
  {
    featureType: 'road',
    stylers: [{ color: '#cad8e6' }],
  },
  {
    featureType: 'landscape',
    stylers: [{ color: '#E4EFFA' }],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [{ color: '#bad1e8' }],
  },
  {
    featureType: 'water',
    stylers: [{ color: '#9EC4E7' }],
  },
]

export default mapStyle
